import { gql } from '@apollo/client';

/**
 * UPDATE_CARD_REFERENCES_MUTATION
 * 
 * Updates the reference1 and reference2 fields for a card (used for naming cards, etc.)
 * 
 * @param cardId - The ID of the card to update
 * @param reference1 - First reference field (typically used for card name)
 * @param reference2 - Second reference field (optional additional reference)
 * 
 * @returns Updated card with all fields
 */
export const UPDATE_CARD_REFERENCES_MUTATION = gql`
	mutation UpdateCardReferences($cardId: Int!, $reference1: String!, $reference2: String!) {
		updateCardReferences(
			input: { cardId: $cardId, reference1: $reference1, reference2: $reference2 }
		) {
			card {
				brandId
				expiresAt
				id
				maskedPan
				name
				number
				receiptText
				reference1
				reference2
				updated
				updatedBy
			}
		}
	}
`;

/**
 * UPDATE_CARD_PIN_MUTATION
 * 
 * Updates the PIN code for a card
 * 
 * @param cardId - The ID of the card to update
 * @param pinCode - The new PIN code (4 digits as integer)
 * 
 * @returns Updated card with confirmation fields
 */
export const UPDATE_CARD_PIN_MUTATION = gql`
	mutation UpdateCardPinCode($cardId: Int!, $pinCode: Int!) {
		updateCardPinCode(input: { cardId: $cardId, pinCode: $pinCode }) {
			card {
				id
				updated
				updatedBy
				number
				type {
					id
					isCustomerCard
					name
					shortName
				}
			}
		}
	}
`;

/**
 * DISABLE_CARD_MUTATION
 * 
 * Disables a card, preventing further use
 * 
 * @param cardId - The ID of the card to disable
 * @param reason - The reason for disabling the card (e.g., "By user")
 * 
 * @returns Updated card with disabled status information
 */
export const DISABLE_CARD_MUTATION = gql`
	mutation DisableCard($cardId: Int!, $reason: String!) {
		disableCard(input: { cardId: $cardId, reason: $reason }) {
			card {
				name
				id
				updated
				updatedBy
				maskedPan
				type {
					id
					isCustomerCard
					name
					shortName
				}
				limit {
					disabled {
						at
						isDisabled
						reason
					}
				}
			}
		}
	}
`;
